<template lang="pug">
.IndustryLibrary
  .title 风险库
  .filter
    .filter_left
      BaseSingleSelect(
        :optionList="optionList",
        :checked.sync="checked",
        @changed="getData"
      )
      ChooseIndustryAndRiskDialog
    BaseMoreButton(path="/collect")
  RiskLibraryList(:list="list", v-loading="loading")
</template>

<script>
import client from '@index/server/server'
import BaseSingleSelect from '@index/components/BaseSingleSelect.vue'
import RiskLibraryList from './RiskLibraryList.vue'
import BaseMoreButton from '../components/BaseMoreButton'
import ChooseIndustryAndRiskDialog from '../ChooseIndustryAndRiskDialog/ChooseIndustryAndRiskDialog'
export default {
  components: {
    BaseSingleSelect, RiskLibraryList, BaseMoreButton, ChooseIndustryAndRiskDialog
  },
  data () {
    return {
      list: [],
      loading: false
    }
  },
  computed: {
    optionList () {
      return this.$store.state.user.userinfo.focusCategoryList || []
    }
  },
  watch: {
    optionList: {
      handler () {
        if (this.optionList.length > 0) {
          this.checked = this.optionList[0]
        }
        this.getData()
      },
      immediate: true
    }
  },
  methods: {
    getData () {
      this.loading = true
      client.GetCategoryEvent({
        category: this.checked,
        size: 6
      }).then(res => {
        if (res.success) {
          this.list = res.data.list
        }
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.IndustryLibrary {
  padding-top: 50px;
  .title {
    font-size: 22px;
    color: #333333;
    margin-bottom: 30px;
  }
  .filter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    padding: 10px;
    background-color: #ffffff;
    box-shadow: 3px 3px 12px 1px rgba(94, 103, 116, 0.02);
    border-radius: 6px;
    .filter_left {
      flex: 1;
      width: 0;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventIndex/HomePage/RiskLibrary/RiskLibrary.vue